import { getUserInternalAccessToken } from "@/api/access-token-backoffice";

export interface CampaignTemplate {
  id: number;
  name: string;
  description?: string;
  template: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export async function getCampaignTemplateById(id: number): Promise<CampaignTemplate> {
  try {
    // First attempt: local API (Vite dev server middleware)
    const { accessToken } = await getUserInternalAccessToken();

    const response = await fetch("/api/campaign-templates/get-by-id", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({ id }),
    });

    if (response.ok) {
      const text = await response.text();
      if (text.trim().startsWith("<!DOCTYPE") || text.trim().startsWith("<html")) {
        throw new Error("Internal API not available"); // Force fallback to direct backend call
      }
      const data = JSON.parse(text);
      return data;
    }
    throw new Error("Internal API failed");
  } catch (error) {
    // Fallback: direct call to external backend API
    try {
      const { accessToken } = await getUserInternalAccessToken();
      const backofficeApiUrl =
        import.meta.env.VITE_API_BACKOFFICE_URL || "https://api-backoffice-qas.talk2buy.com.br";
      const response = await fetch(`${backofficeApiUrl}/v1/campaigntemplate/${id}`, {
        method: "GET", // Direct backend API uses GET
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Backend API error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (backendError) {
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.error(`[API] Error fetching campaign template ${id}:`, backendError);
      }
      throw backendError; // Re-throw if direct backend call also fails
    }
  }
}
